import Header from '../Navigation/Header'
import Footer from '../Navigation/Footer'
import { Seo } from '../../helpers/Seo'
import { Link } from 'react-router-dom'
import { Accordion } from '../../components/Accordion'
import { ClientsBanner } from '../../components/ClientsBanner'

export default function MicroLoan100() {
    return (
        <div>
            <Seo
                title="Prêt personnel de 100$ approuvé sans document​ | Trouvez les meilleures offres | Argent Aujourd’hui"
                description="Comparez les prêts personnels de 100$ en ligne sur notre site et choisissez l'option idéale. Accédez aux meilleures offres dès maintenant."
                type="webapp"
                name="Argent Aujourd'hui"
            />
            <Header />

            <section className="header">
                <div data-aos="fade-up">
                    <h1 className="header-title">Prêt personnel de 100$ approuvé sans document​</h1>

                    <p className="header-subtitle">
                        Vous cherchez un prêt personnel de 100$ approuvé sans document? Argent
                        Aujourd’hui compare pour vous les meilleures options de financement de la
                        province pour vous permettre d’obtenir des fonds en moins de 24 heures!
                    </p>

                    <Link to="/new-lead" className="btn">
                        Demander un prêt
                    </Link>
                </div>
            </section>

            <section className="sect sect-bg-dark">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">
                        Obtenir un prêt de 100$, c’est simple et rapide avec Argent Aujourd’hui!
                    </h2>

                    <p className="sect-subtitle">
                        Parfois, des dépenses imprévues arrivent au mauvais moment, même pour de
                        petits montants! Pour vous aider à obtenir un prêt personnel de 100$
                        approuvé sans document, Argent Aujourd’hui étudie pour vous les meilleures
                        options du marché. Notre comparateur en ligne vous permet d’obtenir un prêt
                        rapide personnalisé en 4 étapes simples :
                    </p>

                    <div className="steps" style={{ marginTop: 50 }}>
                        <ol>
                            <li>
                                <h3>
                                    Remplissez notre <Link to="/new-lead">formulaire en ligne</Link>
                                </h3>
                                <p>
                                    Il suffit de partager vos coordonnées et d’indiquer que vous
                                    cherchez un prêt de 100$.
                                </p>
                            </li>
                            <li>
                                <h3>Comparez vos options de financement</h3>
                                <p>
                                    Sur base des renseignements que vous nous avez fournis, nous
                                    vous proposons une série de prêteurs alternatifs qui pourraient
                                    répondre à vos besoins. Prenez le temps de comparer leurs
                                    modalités, dont le délai de remboursement et le prix du prêt.
                                </p>
                            </li>
                            <li>
                                <h3>Faites votre demande de prêt</h3>
                                <p>
                                    Lorsque vous avez choisi une institution, cliquez simplement sur
                                    son nom et vous serez automatiquement redirigé vers son
                                    formulaire de demande. Vous devrez fournir une preuve d’identité
                                    ainsi que des renseignements supplémentaires. Si vous envoyez
                                    votre demande tôt dans la journée, vous pourriez recevoir une
                                    réponse dans les heures qui suivent!
                                </p>
                            </li>
                            <li>
                                <h3>Recevez les fonds en 24 heures</h3>
                                <p>
                                    Une fois votre demande traitée et approuvée, vous devriez
                                    obtenir votre paiement par virement interac dans votre compte
                                    bancaire dans les 24 heures qui suivent!
                                </p>
                            </li>
                        </ol>
                    </div>
                </div>
            </section>

            <section className="sect sect-bg-light">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">Nos autres prêts allant jusqu’à 1 500$</h2>

                    <p className="sect-subtitle">
                        Parce que des imprévus peuvent arriver à tout moment, nos options d’argent
                        rapide sont flexibles! Selon vos besoins, vous pouvez faire une demande pour
                        l’un des montants suivants :
                    </p>

                    <div className="loan-options">
                        <ul>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 200$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 300$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 500$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 700$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 1 000$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 1 500$</li>
                            </Link>
                        </ul>
                    </div>
                </div>
            </section>

            <section className="sect sect-bg-dark">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">Les avantages de notre prêt de 100$</h2>

                    <p className="sect-subtitle">
                        En passant par nos services, vous bénéficiez d’une série d’avantages :
                    </p>

                    <ul className="styled-checklist" style={{ marginTop: 30 }}>
                        <li style={{ marginBottom: 30 }}>
                            <h4>Procédure sûre, confidentielle et 100% gratuite</h4>

                            <span style={{ marginTop: 130 }}>
                                Notre comparateur en ligne vous permet de connaître les différentes
                                options de financement, ce qui ne requiert aucun engagement de votre
                                part!
                            </span>
                        </li>
                        <li style={{ marginBottom: 30 }}>
                            <h4>Prêt IBV</h4>

                            <span style={{ marginTop: 130 }}>
                                Nos prêts sont sans enquête de crédit. Pour vérifier votre capacité
                                de remboursement, les institutions effectuent une vérification
                                bancaire instantanée. Nous ne regardons donc pas votre historique de
                                crédit et la procédure n’affectera pas votre score de crédit.
                            </span>
                        </li>
                        <li style={{ marginBottom: 30 }}>
                            <h4>Des partenaires québécois vérifiés</h4>

                            <span style={{ marginTop: 130 }}>
                                Toutes les options de prêts à court terme que nous vous proposons
                                sont offertes par des institutions québécoises enregistrées au{' '}
                                <a
                                    href={
                                        'https://www.quebec.ca/entreprises-et-travailleurs-autonomes/obtenir-renseignements-entreprise/recherche-registre-entreprises'
                                    }
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Registre des entreprises du Québec.
                                </a>
                            </span>
                        </li>
                        <li style={{ marginBottom: 30 }}>
                            <h4>Une solution rapide et efficace</h4>

                            <span style={{ marginTop: 130 }}>
                                La démarche se fait entièrement en ligne et vous permet d’obtenir un
                                prêt par virement interac dans un délai de 24 heures.
                            </span>
                        </li>
                    </ul>
                </div>
            </section>

            <section className="sect sect-bg-light">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">Pour quel besoin utiliser notre prêt de 100$?</h2>

                    <p className="sect-subtitle">
                        Que vous ayez une facture inattendue ou une réparation urgente à faire, vous
                        n’avez pas à expliquer la raison de votre emprunt! Nous vous proposons des
                        prêts de 100$ sans justificatif et sans refus, qui répondent à vos besoins
                        immédiats :
                    </p>

                    <ul className="styled-checklist" style={{ marginTop: 20 }}>
                        <li>Prêt d’urgence </li>
                        <li>Avance de fonds </li>
                        <li>Prêt sur salaire </li>
                        <li>Prêt mauvais crédit</li>
                    </ul>
                </div>
            </section>

            <section className="sect sect-bg-dark">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">
                        Questions fréquemment posées sur les prêts personnels de 100$
                    </h2>

                    <div style={{ marginTop: 50 }}>
                        <Accordion
                            items={[
                                {
                                    title: 'Comment puis-je emprunter 100 $ rapidement?',
                                    content: (
                                        <p>
                                            <Link to="/new-lead">
                                                Remplissez une demande en ligne
                                            </Link>{' '}
                                            avec Argent Aujourd’hui et choisissez un prêteur qui
                                            répond à vos besoins. Les fonds sont généralement
                                            transférés par virement interac dans les 24 heures.
                                        </p>
                                    ),
                                },
                                {
                                    title: 'Puis-je obtenir un prêt de 100 $ avec un mauvais crédit?',
                                    content: (
                                        <p>
                                            Oui! Nos prêts sans vérification de crédit sont
                                            accessibles pour les personnes ayant un mauvais crédit
                                            ou des antécédents de crédit limités.
                                        </p>
                                    ),
                                },
                                {
                                    title: "Qu'est-ce qu'un prêt personnel de 100 $ approuvé?",
                                    content: (
                                        <p>
                                            Il s'agit d'un type de prêt à court terme qui offre une
                                            approbation garantie aux demandeurs admissibles, ce qui
                                            leur assure un accès rapide à des fonds en cas
                                            d'urgence.
                                        </p>
                                    ),
                                },
                            ]}
                        />
                    </div>
                </div>
            </section>

            <section className="Eligible sect-bg-light">
                <div className="card" data-aos="fade-up">
                    <div className="content">
                        <div className="section-title">
                            <h2>Êtes-vous éligible?</h2>
                        </div>
                        <p>
                            Pour obtenir un prêt personnel de 100$ approuvé sans document
                            rapidement, vous devez répondre aux critères suivants :
                        </p>
                        <ul>
                            <li>Avoir au moins 18 ans</li>
                            <li>Résider au Québec</li>
                            <li>Avoir un revenu stable</li>
                            <li>Ne pas avoir d’opposition de paiement</li>
                            <li>
                                Avoir le moins de frais de fonds non suffisants possible (frais NSF)
                            </li>
                        </ul>
                        <p>
                            Vous cherchez un prêt personnel de 100$ approuvé sans emploi? Nos prêts
                            sont sans justificatif de salaire et sans vérification de votre cote de
                            crédit.
                        </p>
                        <Link to="/new-lead" className="btn">
                            Demander un prêt
                        </Link>
                    </div>
                </div>
            </section>

            <ClientsBanner />

            <Footer />
        </div>
    )
}
